import { Component, h } from 'preact'
import ColorPicker from '../theme-configuration/ColorPicker'
import { colorOptions } from './Types'

interface Props {
  title: string,
  colors: Array<string>,
  selectedColor: string,
  type: colorOptions,
  onCallback: (newData: {
    [key: colorOptions]: string
  }) => void,
  qaClasses: string
}

interface State {
  enablePicker: boolean
}

class IdeationAddColor extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      enablePicker: false
    }
  }

  render (props: Props, state: State) {
    return (
      <ColorPicker
        color={props.selectedColor}
        disabled={false}
        disableColorSelector={() => this.setState({ enablePicker: false })}
        setColorSelector={() => this.setState({ enablePicker: true })}
        updateColor={(newColor: string) => props.onCallback({ [props.type]: newColor })}
        isColorSelectorEnabled={this.state.enablePicker}
        disableAlpha
        presetColors={props.colors}
      />
    )
  }
}

export default IdeationAddColor
